// extracted by mini-css-extract-plugin
export var container = "notification-settings-module--container--e5456";
export var header = "notification-settings-module--header--3412a";